// lib/annotation-snapshot.ts
// Helpers partagés par les endpoints d'annotation RLHF (list + entry) et le moteur de forensics.
// Volontairement sans dépendance à la base : ce module est atteignable depuis le bundle client
// via lib/project-success/forensicsEngine.ts. Les stats serveur vivent dans lib/annotation-stats.ts.

const PROMPT_KEYS = ['prompt', 'textPrompt', 'promptText', 'inputPrompt', 'input_prompt'];
const OBJECT_ID_REGEX = /^[0-9a-fA-F]{24}$/;

export const isValidObjectId = (value?: string | null) =>
  typeof value === 'string' && OBJECT_ID_REGEX.test(value);

export const escapeLike = (value: string) => value.replace(/[\\%_]/g, '\\$&');

export const getPromptFromParams = (params: unknown, fallback?: string | null) => {
  if (typeof params === 'string' && params.trim().length > 0) {
    return params.trim();
  }

  if (params && typeof params === 'object' && !Array.isArray(params)) {
    const record = params as Record<string, unknown>;
    for (const key of PROMPT_KEYS) {
      const value = record[key];
      if (typeof value === 'string' && value.trim().length > 0) {
        return value.trim();
      }
    }
  }

  if (typeof fallback === 'string' && fallback.trim().length > 0) {
    return fallback.trim();
  }

  return null;
};

export const normalizePrompt = (value: string) => value.replace(/\s+/g, ' ').trim();

export const extractAssistantPrompts = (script: unknown) => {
  const prompts = new Set<string>();

  const visit = (node: unknown) => {
    if (!node) return;
    if (Array.isArray(node)) {
      node.forEach(visit);
      return;
    }
    if (typeof node === 'object') {
      Object.entries(node as Record<string, unknown>).forEach(([key, value]) => {
        if (key === 'prompt' && typeof value === 'string') {
          const normalized = normalizePrompt(value);
          if (normalized.length > 0) {
            prompts.add(normalized);
          }
          return;
        }
        visit(value);
      });
    }
  };

  visit(script);
  return prompts;
};

export const normalizeSnapshotUrl = (url: string | null | undefined): string | null => {
  if (!url) return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('http') || trimmed.startsWith('/') || trimmed.startsWith('data:')) {
    return trimmed;
  }
  // Assume it's ownerId/fileName path from Azure Storage
  return `/api/assets/${trimmed}`;
};

export const buildUserLabel = (user: { firstName?: string | null; lastName?: string | null; email?: string | null } | null) => {
  if (!user) return null;
  const firstName = user.firstName?.trim();
  const lastName = user.lastName?.trim();
  const nameParts = [firstName, lastName].filter(Boolean) as string[];
  if (nameParts.length) return nameParts.join(' ');
  const email = user.email?.trim();
  return email && email.length > 0 ? email : null;
};
